module.exports = __webpack_public_path__ + "static/media/15.c3f38676.jpeg";